import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { IDailySignOffSettings } from 'types/DailySignOffSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useDailySignOffSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof IDailySignOffSettings>(keysAndPayloads: { key: K; payload: IDailySignOffSettings[K] }[]) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.dailySignOff);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('dailySignOff', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
